import { api } from '@/shared/api/api-client';
import { ENDPOINTS } from '@/shared/api/endpoints';
import type {
  NotificationFilter,
  NotificationList,
} from '../models/notification.types';

export function getNotifications(
  filter: NotificationFilter = 'all',
): Promise<NotificationList> {
  const query = filter === 'all' ? '' : `?filter=${filter}`;
  return api().get<NotificationList>(`${ENDPOINTS.me.notifications}${query}`);
}

export function markNotificationRead(id: string): Promise<{ ok: true }> {
  return api().patch<{ ok: true }>(ENDPOINTS.me.notificationRead(id), {});
}

export function markAllNotificationsRead(): Promise<{ ok: true }> {
  return api().patch<{ ok: true }>(ENDPOINTS.me.notificationsReadAll, {});
}
